import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=48fa6687&scoped=true&"
import script from "./hamburger.vue?vue&type=script&lang=ts&"
export * from "./hamburger.vue?vue&type=script&lang=ts&"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=48fa6687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa6687",
  null
  
)

export default component.exports